import CloseCurrentTab from './auth/components/CloseCurrentTab.tsx'
import ErrorAuthComponent from './auth/errorauth.component.jsx'
import ExternalSignIn from './auth/externalsignin.component.jsx'
import ForgotPasswordPage from "./auth/pages/ForgotPasswordPage"
import ResetPasswordPage from "./auth/pages/ResetPasswordPage"
import SignIn from './auth/signin.component.jsx'
import SignUp from './auth/signup.component.jsx'
import PDFErrorPage from "./common/pdf/PDFErrorPage"
import NewInvoiceController from './embed/shopify/newinvoicecontroller.component.jsx'
import NewQuoteController from './embed/shopify/newquotecontroller.component.jsx'
import ReceivePaymentController from './embed/shopify/receivepaymentcontroller.component.jsx'
import ProposalPdf from './proposal/pdf.component.jsx'
import Proposal from './proposal/proposal.component.jsx'
import ProposalSample from "./proposal/sample.component.jsx"
import ProposalWord from "./proposal/word.component.jsx"
import SchedulingPageBookingThankYou from "./scheduling-page/thankyou.component.jsx"
import SpiffLeaderboard from "./staff/leaderboard.component.jsx"
import WorkOrderReceiptPdf from "./workorder/receipt/pdf.component.jsx"
import WorkOrderReceipt from "./workorder/receipt/receipt.component.jsx"

// should be separated by '|', e.g. "ls-retail|quick-books|kangaroo"
const supportedSignUpIntegrations = "ls-retail|shopify|shopify-expert-app|ls-ecom|ls-ecom-omni|ls-ecom-omni-na|vend|square|quick-books"
const supportedSignUpModals = "create-invoice|receive-payment"

// Each logical "route" has two components, one for
// the sidebar and one for the main area. We want to
// render both of them in different places when the
// path matches the current URL.
const AppRoutes = [
    {
        path: '/p/signin',
        exact: true,
        main: SignIn,
        centered: true,
    },
    {
        path: `/p/auth/error/:integrationKey(${supportedSignUpIntegrations})`,
        exact: true,
        main: ErrorAuthComponent,
        centered: true,
    },
    {
        path: `/p/signin/:integrationKey(${supportedSignUpIntegrations})`,
        exact: true,
        main: ExternalSignIn,
        centered: true,
    },
    {
        path: "/p/embed/shopify/receive-payment",
        exact: true,
        main: ReceivePaymentController,
        centered: true,
    },
    {
        path: "/p/embed/shopify/new-invoice",
        exact: true,
        main: NewInvoiceController,
        centered: true,
    },
    {
        path: "/p/embed/shopify/new-quote",
        exact: true,
        main: NewQuoteController,
        centered: true,
    },
    {
        path: '/p/signup',
        exact: true,
        main: SignUp,
        centered: true,
    },
    {
        path: `/p/signup/:integrationKey(${supportedSignUpIntegrations})`,
        exact: true,
        main: SignUp,
        centered: true,
    },
    {
        path: '/p/forgot-password',
        exact: true,
        main: ForgotPasswordPage,
        centered: true,
    },
    {
        path: '/p/reset-password/:userID/:hash',
        exact: true,
        main: ResetPasswordPage,
        centered: true,
    },
    {
        path: '/p/work-order-receipts/:hash',
        exact: true,
        main: WorkOrderReceipt,
        centered: true,
    },
    {
        path: '/p/work-order-receipts/:hash/pdf',
        exact: true,
        main: WorkOrderReceiptPdf,
        centered: true,
    },
    {
        path: '/p/proposals/:hash',
        exact: true,
        main: Proposal,
        centered: false,
    },
    {
        path: '/p/proposals/:hash/pdf',
        exact: true,
        main: ProposalPdf,
        centered: false,
    },
    {
        path: '/p/proposals/:hash/sample',
        exact: true,
        main: ProposalSample,
        centered: false,
    },
    {
        path: '/p/proposals/:hash/word',
        exact: true,
        main: ProposalWord,
        centered: false,
    },
    {
        path: '/p/lightspeed/spiff-leaderboard',
        exact: true,
        main: SpiffLeaderboard,
        centered: false,
    },
    {
        path: '/p/close-current-tab',
        exact: true,
        main: CloseCurrentTab,
        centered: false,
    },
    {
        path: '/p/embed/scheduling-pages/:schedulingPageId/thank-you',
        exact: true,
        main: SchedulingPageBookingThankYou,
    },
    {
        path: '/p/pdf/error',
        exact: true,
        main: PDFErrorPage,
    }

]

export default AppRoutes


// WEBPACK FOOTER //
// ./src/publicroutes.jsx